import Paper from '@mui/material/Paper';

export { Paper };
